<div class="container-full bg-gradient">
    <form id="emailForm" [formGroup]="emailForm" (ngSubmit)="sendCode()" [hidden]="step != 1">
        <mat-card>
            <img src="assets/logo-inline.png" class="logo mb-4"/>
            <mat-card-header>
                <mat-card-title>Réinitialiser votre mot de passe</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <app-alert></app-alert>
                <div class="form-group">
                    <mat-form-field>
                        <mat-label>E-mail</mat-label>
                        <input matInput formControlName="username" placeholder="E-mail" class="text">
                        <mat-error
                            *ngIf="emailForm.get('username').invalid">{{ formService.getErrorMessage(emailForm.get('username')) }}
                        </mat-error>
                    </mat-form-field>
                </div>
            </mat-card-content>
            <mat-card-actions>
                <button class="btn btn-primary w-100" [disabled]="emailForm.invalid">
                    <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                    Valider
                </button>
                <a href="/app/login" class="mt-2 d-block"><i class="fa fa-caret-left"></i> Retour</a>
            </mat-card-actions>
        </mat-card>
    </form>
    <form id="passwordForm" [formGroup]="passwordForm" (ngSubmit)="sendNewPassword()" [hidden]="step != 2">
        <mat-card>
            <img src="assets/logo-inline.png" class="logo mb-4"/>
            <mat-card-header>
                <mat-card-title>Nouveau mot de passe</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <app-alert></app-alert>

                <div class="alert alert-success">
                    Un code de vérification à été envoyé sur votre mail.
                </div>

                <div class="form-group">
                    <mat-form-field>
                        <mat-label>Code à 6 chiffres recu par mail</mat-label>
                        <input matInput formControlName="code" placeholder="E-mail" class="text">
                        <mat-hint>Code envoyé à l'adresse : {{ emailForm.get('username').value }}
                        </mat-hint>
                        <mat-error
                            *ngIf="passwordForm.get('code').invalid">{{ formService.getErrorMessage(passwordForm.get('code')) }}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="form-group">
                    <mat-form-field>
                        <mat-label>Nouveau mot de passe</mat-label>
                        <input matInput formControlName="password" [type]="hide ? 'password' : 'text'" class="text">
                        <p mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
                           [attr.aria-pressed]="hide">
                            <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
                        </p>
                        <mat-error
                            *ngIf="passwordForm.get('password').invalid">{{ formService.getErrorMessage(passwordForm.get('password')) }}
                        </mat-error>
                    </mat-form-field>
                </div>
            </mat-card-content>
            <mat-card-actions>
                <button class="btn btn-primary w-100" [disabled]="passwordForm.invalid">
                    <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                    Valider
                </button>
                <a href="/app/login" class="mt-2 d-block"><i class="fa fa-caret-left"></i> Retour</a>
            </mat-card-actions>
        </mat-card>
    </form>
</div>
